import React, { forwardRef } from "react";
import { Form, FormBuilder } from "@redriver/cinnamon";
import { Accordion, Button, Icon } from "semantic-ui-react";
import { PermissionCheck } from "features/../../../shared/components/auth";
import { Actions, Targets } from "features/../../app/constants/permissions";
import { IconButton } from "features/../../../shared/components/buttons";
import Pen from "features/../../../shared/assets/pen.svg";
import Save from "features/../../../shared/assets/save.svg";
import {
  getSalesRequestRestrictions,
  updateSalesRequestRestrictions,
} from "features/Dealers/DealerOffice/Settings/RestrictionSettings/SalesRequests/actions";

const SalesRequests = forwardRef(
  ({ settingsId, toggleVisibility, collapsed }, ref) => {
    return (
      <React.Fragment>
        <div ref={ref} className="cost-per-device-title">
          <FormBuilder
            initialReadOnly
            loadAction={getSalesRequestRestrictions}
            loadParams={{ settingsId }}
            submitAction={updateSalesRequestRestrictions}
            submitParams={{ settingsId }}
            renderLoading={false}
            renderSubmitting={false}
            renderError={false}
            renderForm={(formProps, state, events) => {
              return (
                <Accordion className="sales-requests-settings">
                  <Accordion.Title
                    active={!collapsed}
                    onClick={toggleVisibility}
                  >
                    <div ref={ref}>
                      <div onClick={toggleVisibility}>
                        <div className="title">
                          <h5>Sales Requests</h5>
                          {toggleVisibility && (
                            <Icon
                              name="dropdown"
                              rotated={collapsed ? "counterclockwise" : null}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </Accordion.Title>
                  <Accordion.Content active={!collapsed}>
                    <div className="defaults-page-title flex">
                      <div className="flex title-bar"></div>
                      <PermissionCheck
                        target={Targets.DefaultsRestrictions}
                        action={Actions.Edit}
                      >
                        <div className="sales-requests-settings-edit">
                          <IconButton
                            primary
                            icon={state.readOnly ? Pen : Save}
                            content={state.readOnly ? "Edit" : "Save"}
                            floated="right"
                            onClick={() =>
                              state.readOnly
                                ? events.onToggleReadOnly()
                                : events.onSubmit({ reset: ["readOnly"] })
                            }
                            className={
                              !state.readOnly ? "positive-title-action" : null
                            }
                            loading={state.loading || state.submitting}
                            disabled={state.loading || state.submitting}
                          />
                          {!state.readOnly && (
                            <Button
                              primary
                              className="cancel-title-action"
                              floated="right"
                              content="Cancel"
                              onClick={events.onReset}
                            />
                          )}
                        </div>
                      </PermissionCheck>
                    </div>
                    <Form {...formProps} className="">
                      <div className="sales-requests-settings-box">
                        <div className="title">Sales Request Settings</div>
                        <Form.Checkbox
                          label="Override sales requests"
                          field="overrideSalesRequestRestrictions"
                          disabled={state.readOnly}
                        />
                      </div>
                    </Form>
                  </Accordion.Content>
                </Accordion>
              );
            }}
          />
        </div>
      </React.Fragment>
    );
  },
);
export default SalesRequests;
